import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Dashboard components
import Sales from "layouts/dashboard/components/Sales";

function Dashboard() {
  const courses = useSelector((state) => state.course.allCourses);
  const lessons = useSelector((state) => state.lesson.allLessons);
  const users = useSelector((state) => state.user.allUsers);
  const [authors, setAuthors] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    setAuthors(users.filter((c) => c.roles.includes("ROLE_AUTHOR")));
    setClients(users.filter((c) => c.roles.includes("ROLE_SUBSCRIBER")));
  }, [users]);

  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="dark"
              icon="library_books"
              title="Cours"
              count={courses.length}
              percentage={{
                color: "success",
                amount: "",
                label: "Nombre de cours",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              icon="menu_book"
              title="Léçons"
              count={lessons.length}
              percentage={{
                color: "success",
                amount: "",
                label: "Nombre de léçons",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="success"
              icon="people"
              title="Auteurs"
              count={authors.length}
              percentage={{
                color: "success",
                amount: "",
                label: "Nombre d'auteurs",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="primary"
              icon="account_circle"
              title="Abonnés"
              count={clients.length}
              percentage={{
                color: "success",
                amount: "",
                label: "Nombre de clients",
              }}
            />
          </MDBox>
        </Grid>
      </Grid>
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <Sales />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default Dashboard;
